import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAuditLog } from '@/services/api';
import { ScrollArea } from '@/components/ui/scroll-area';

export function AuditTab() {
  const { data, isLoading } = useQuery({ queryKey: ['audit-log'], queryFn: fetchAuditLog });
  const logs = data?.data || [];

  return (
    <ScrollArea className="h-96">
      {isLoading ? (
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-10 rounded-xl animate-pulse" style={{ background: 'var(--vz-bg-elevated)' }} />
          ))}
        </div>
      ) : logs.length === 0 ? (
        <div className="flex items-center justify-center h-40">
          <p className="text-sm" style={{ color: 'var(--vz-text-muted)' }}>No hay registros de auditoría</p>
        </div>
      ) : (
        <div className="space-y-2">
          {logs.map((log, i) => (
            <div key={i} className="flex items-start gap-3 p-3 rounded-xl" style={{ background: 'var(--vz-bg-elevated)' }}>
              <div className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0" style={{ background: '#4A9EFF' }} />
              <div>
                <p className="text-xs font-medium text-white">{log.action}</p>
                <p className="text-[10px] font-mono" style={{ color: 'var(--vz-text-muted)' }}>{log.created_at}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </ScrollArea>
  );
}
